module.exports = __webpack_public_path__ + "img/macbook-pro.e535ed6b.svg";